import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { clientConfig } from './config/clientConfig';
import { simulationService } from './services/simulation';
import { storageController } from './controllers/StorageController';
import './i18n/config';
import './index.css';

if (clientConfig.shouldMockServices) {
  (window as unknown as Record<string, unknown>).__e2e = {
    simulation: simulationService,
    storage: storageController,
    config: clientConfig,
  };
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
